import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Boot splash hand-off (see index.html).
//
// The splash background paints immediately -- that is the whole point, it is what
// stands in for a white page. The SPINNER is deliberately late: it fades in at
// 300ms (CSS), so a fast load never shows one. Two rules follow from that:
//
//   - mounted before the spinner appeared -> tear down at once, no flash.
//   - spinner did appear -> leave it up long enough to actually read, rather
//     than blinking it out mid-fade-in, which looks like a glitch.
//
// Time is measured from __WG_BOOT_AT (stamped in index.html when the splash was
// parsed), NOT from navigation start: on a slow connection the HTML lands late,
// so the CSS animation clock starts late too, and performance.now() would say
// the spinner had been up for a second when it had not yet appeared.
const SPINNER_DELAY_MS = 300; // must match the animation-delay in index.html
const MIN_SPINNER_MS = 600;

requestAnimationFrame(() =>
  requestAnimationFrame(() => {
    const boot = document.getElementById('wg-boot');
    if (!boot) return;
    const bootAt =
      (window as unknown as { __WG_BOOT_AT?: number }).__WG_BOOT_AT ?? 0;
    const elapsed = performance.now() - bootAt;
    const wait =
      elapsed < SPINNER_DELAY_MS
        ? 0
        : Math.max(0, SPINNER_DELAY_MS + MIN_SPINNER_MS - elapsed);
    setTimeout(() => {
      boot.classList.add('wg-boot--done');
      boot.addEventListener('transitionend', () => boot.remove(), {
        once: true,
      });
      // transitionend does not fire under prefers-reduced-motion or if the tab is
      // backgrounded mid-fade; never leave the splash pinned over the app.
      setTimeout(() => boot.remove(), 800);
    }, wait);
  }),
);
